<a class="nav-link" ngbDropdownToggle id="notificationDropdown">
  <i class="link-icon feather icon-bell"></i>
  <div class="indicator" *ngIf="notificationLight">
    <div class="circle"></div>
  </div>
</a>
<div ngbDropdownMenu class="px-0" aria-labelledby="notificationDropdown">
  <div
    class="px-3 py-2 d-flex align-items-center justify-content-between border-bottom"
  >
    <!-- <p *ngIf="unreadCount > 6">6+ Unread Notifications</p> -->
    <p>{{ unreadCount }} Unread Notifications</p>
    <a href="" (click)="markAllAsRead($event)" class="text-muted text-end"
      >Read All</a
    >
  </div>
  <div class="notifications-list py-2">
    <div *ngFor="let notification of NOTIFICATIONS">
      <a
        href="#"
        (click)="(false)"
        class="dropdown-item d-flex align-items-center py-2"
        [ngClass]="{ unreadNotification: notification.read_receipt == 0 }"
        (click)="navigateToNotification(notification.id)"
      >
        <div
          class="wd-30 ht-30 d-flex align-items-center justify-content-center bg-info rounded-circle me-3"
        >
          <i
            class="feather icon-alert-circle icon-sm text-white font-weight-normal"
          ></i>
        </div>
        <div class="flex-grow-1 me-2">
          <p class="text-body">{{ notification.heading }}</p>
          <p class="tx-12 text-muted">
            {{ notification.created | timeDifference }}
          </p>
        </div>
      </a>
    </div>
  </div>
  <!-- <div class="notifications-list py-2">
    <a
      href="#"
      (click)="(false)"
      class="dropdown-item d-flex align-items-center py-2"
      *ngFor="let notification of NOTIFICATIONS"
      [ngClass]="{ unreadNotification: notification.read_receipt == 0 }"
      (click)="navigateToNotification(notification.id)"
    >
      <div
        class="wd-30 ht-30 d-flex align-items-center justify-content-center bg-info rounded-circle me-3"
      >
        <i
          class="feather icon-alert-circle icon-sm text-white font-weight-normal"
        ></i>
      </div>
      <div class="flex-grow-1 me-2">
        <p class="text-body">{{ notification.heading }}</p>
        <p class="tx-12 text-muted">
          {{ notification.created | timeDifference }}
        </p>
      </div>
    </a>
  </div> -->

  <div
    class="px-3 py-2 d-flex align-items-center justify-content-center border-top"
  >
    <a (click)="openAllNotifications()" class="btn btn-primary btn-block">
      View all
    </a>
  </div>
</div>
<audio id="notificationSound">
  <source src="assets/sounds/notification-sound.mp3" type="audio/mpeg" />
</audio>
